<template>
  <div class="module-sub-qa">
    <div class="module-sub-qa-q">
      <div class="module-sub-qa-q-left">
        <img class="avatar" :src="question.src" />
      </div>
      <div class="module-sub-qa-q-middle">
        <ReadMoreText class="module-sub-qa-q-middle-desc" :text="question.message"></ReadMoreText>
      </div>
      <div class="module-sub-qa-q-right">{{question.sendTime}}</div>
    </div>
    <div :class="['module-sub-qa-a', {last: isLast}]">
      <div class="module-sub-qa-a-left">
        <img class="avatar" :src="answer.src" />
      </div>
      <div class="module-sub-qa-a-middle">
        <div>
          <span class="module-sub-qa-a-middle-name">{{answer.name}}</span>
          <span class="module-sub-qa-a-middle-title">{{answer.title}}</span>
        </div>
        <ReadMoreText class="module-sub-qa-a-middle-desc" :text="answer.message"></ReadMoreText>
      </div>
      <div class="module-sub-qa-a-right">{{answer.sendTime}}</div>
    </div>
  </div>
</template>

<script>
import Avatar from 'vue-avatar'
import { ReadMoreText } from '@/components'

const defaultData = {
  name: '',
  title: '',
  src: '',
  message: '',
  sendTime: ''
}

export default {
  components: {
    Avatar,
    ReadMoreText
  },
  props: {
    question: {
      type: Object,
      default () { return defaultData }
    },
    answer: {
      type: Object,
      default () { return defaultData }
    },
    isLast: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "var.css";

@media screen and (min-width: 400px) {
  .module-sub-qa {
    margin-left: 53px;
    padding-top: 35px;

    & .module-sub-qa-q {
      display: flex;
      position: relative;

      & .module-sub-qa-q-left {

        & .avatar {
          width: 60px;
          border-radius: 50%;
          overflow: hidden;
        }
      }

      & .module-sub-qa-q-middle {
        flex: 1;
        vertical-align: top;
        margin: 0 0 0 29px;
        min-height: 60px;

        & .module-sub-qa-q-middle-desc {
          font-size: 16px;
        }
      }

      & .module-sub-qa-q-right {
        margin-right: 44px;
        color: var(--colorDisabled);
        font-size: 14px;
      }
    }

    & .module-sub-qa-a {
      display: flex;
      position: relative;
      padding-top: 20px;
      margin-left: 88px;
      padding-bottom: 34px;
      border-bottom: 1px solid var(--colorGray4);

      & .module-sub-qa-a-left {
        display: inline-block;

        & .avatar {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          overflow: hidden;
        }
      }

      & .module-sub-qa-a-middle {
        flex: 1;
        vertical-align: top;
        margin: 0 0 0 29px;
        min-height: 60px;

        & .module-sub-qa-a-middle-name {
          color: var(--colorMain);
          font-size: 16px;
          font-weight: bold;
        }
        & .module-sub-qa-a-middle-title {
          color: var(--colorGray1);
          font-size: 14px;
        }
        & .module-sub-qa-a-middle-desc {
          padding-top: 15px;
          color: var(--colorGray0);
          font-size: 14px;
        }
      }

      & .module-sub-qa-a-right {
        margin-right: 44px;
        color: var(--colorDisabled);
        font-size: 14px;
      }

      &.last {
        border-bottom: none;
      }
    }
  }
}

@media screen and (max-width: 400px) {
  .module-sub-qa {
    width: 92%;
    margin: 0 auto 5.3%;

    & .module-sub-qa-q {
      position: relative;

      & .module-sub-qa-q-left {
        display: inline-block;
        width: 11%;

        & .avatar {
          width: 100%;
          border-radius: 50%;
          overflow: hidden;
        }
      }

      & .module-sub-qa-q-middle {
        position: relative;
        display: inline-block;
        vertical-align: top;
        padding: 0 0 0 2.5%;
        width: 85%;
        min-height: 40px;

        & .module-sub-qa-q-middle-desc {
          font-size: 13px;
        }
      }

      & .module-sub-qa-q-right {
        position: relative;
        padding: 0 0 0 15%;
        color: var(--colorDisabled);
        font-size: 12px;
      }
    }

    & .module-sub-qa-a {
      position: relative;
      padding: 4.6% 0 0 10.5%;
      border-bottom: 1px solid var(--colorGray4);

      & .module-sub-qa-a-left {
        display: inline-block;
        width: 11%;

        & .avatar {
          width: 100%;
          border-radius: 50%;
          overflow: hidden;
        }
      }

      & .module-sub-qa-a-middle {
        position: relative;
        display: inline-block;
        vertical-align: top;
        padding: 0 0 0 2.5%;
        width: 85%;

        & .module-sub-qa-a-middle-name {
          color: var(--colorMain);
          font-size: 14px;
          font-weight: bold;
        }

        & .module-sub-qa-a-middle-title {
          color: var(--colorGray1);
          font-size: 10px;
        }

        & .module-sub-qa-a-middle-desc {
          padding-top: 2%;
          color: var(--colorGray0);
          font-size: 13px;
          min-height: 35px;
        }
      }

      & .module-sub-qa-a-right {
        position: relative;
        padding: 0 0 5.3% 15%;
        color: var(--colorDisabled);
        font-size: 12px;
      }

      &.last {
        border-bottom: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/module/sub/Qa.vue